import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/userInfo.js'
import meta from './modules/meta.js'
import reportSettings from './modules/reportSettings.js'
import docs from './modules/docs.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    meta,
    reportSettings,
    docs
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js